import { Theme } from '@/@types/theme';
import { THEME_ENUM } from '@/constants/theme.constant';

export const themeConfig: Theme = {
  mode: THEME_ENUM.MODE_LIGHT,
  direction: THEME_ENUM.DIR_LTR,
  sideNavCollapse: false,
};
